export default __webpack_public_path__ + "static/12-6a60c443a14e2755f65bea78d3486419.jpg";